import { useNavigate } from 'react-router-dom'
import { useCelebration } from '../../contexts/CelebrationContext'
import { TUTORIAL_COPY } from '../../constants/tutorialContent'
import { Button } from '../ui/button'

/**
 * TutorialCompletion — step 8 wrap-up. The celebration system owns the
 * reward moment (art spec §5); this panel renders the bundle + the three
 * pointer-cards (Daily Rewards / Achievements / Codex) as visible locks.
 */

export default function TutorialCompletion({ onClose }) {
    const navigate = useNavigate()
    const { celebrateLevelUp } = useCelebration()

    const handleClose = () => {
        try {
            celebrateLevelUp(1) // existing celebration FX — no new asset, no new system
        } catch {
            /* celebration is garnish; never block the close */
        }
        onClose()
    }

    return (
        <div className="tcd-modal-scrim" data-testid="tutorial-completion">
            <div className="tcd-welcome" role="dialog" aria-label={TUTORIAL_COPY.completion.title}>
                <div className="tcd-callout__chip">{TUTORIAL_COPY.completion.bundleLabel}</div>
                <h2 className="tcd-callout__title" style={{ fontSize: 'var(--font-size-xl)' }}>
                    {TUTORIAL_COPY.completion.title}
                </h2>
                <p className="tcd-callout__body">{TUTORIAL_COPY.completion.body}</p>
                <div className="tcd-completion__pointers">
                    {TUTORIAL_COPY.completion.pointers.map((p) => (
                        <button
                            key={p.label}
                            type="button"
                            className="tcd-pointer"
                            onClick={() => navigate(p.to)}
                        >
                            <div className="tcd-pointer__label">{p.label}</div>
                            <div className="tcd-pointer__note">{p.note}</div>
                        </button>
                    ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button onClick={handleClose}>{TUTORIAL_COPY.completion.cta}</Button>
                </div>
            </div>
        </div>
    )
}
